import { isFeatureEnabled } from "features/company/companyDetails";
import { FeatureKey } from "myParkdUtils/enums";
import { FC, JSX } from "react";
import { connect } from "react-redux";
import { ReduxState } from "types";


export const PermissionGate: FC<Props> = ({ featurePermissions, featureKey, children }) =>
    isFeatureEnabled(featurePermissions, featureKey) && children;

type OwnProps = {
    featureKey: FeatureKey,
    children: JSX.Element
};
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps & OwnProps;

function mapStateToProps(state: ReduxState) {
    return {
        featurePermissions: state.companyDetails.featurePermissions
    };
}

export default connect(mapStateToProps, null)(PermissionGate);